export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestionar contenedor"])},
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de contenedores"])},
          "not_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aún no tiene exportación asignada"])},
          "edit_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar"])},
          "no_container_attachments": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No hay adjuntos"])},
          "destroy_button_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])},
          "destroy_button_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar contenedor"])},
          "destroy_button_message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¿Está seguro de eliminar el contenedor?"])},
          "destroy_button_label_confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])},
          "attachs": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adjuntos"])},
          "total_number_attachs": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Archivos adjuntos"])},
          "destroy_button_attach_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar adjunto"])},
          "destroy_button_attach_message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¿Está seguro de eliminar el adjunto?"])},
          "destroy_button_attach_label_confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])}
        }
      }
    }
  })
}